import React, { useCallback, useMemo } from 'react';
import { Button, Modal } from '@cognitiv/cyprus-ui';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { useAppDispatch, useAppSelector } from 'ducks/hooks';
import { selectWarning } from 'ducks/modals/selectors';
import { setModal } from 'ducks/modals/slices';
import { selectSettings } from 'ducks/settings/selectors';
import { useSwitchTheme } from 'hooks/useSwitchTheme';
import { shallowEqual } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import cn from 'modals/utility/Utility.module.scss';
const { PUBLIC_URL } = process.env;
export const Warning = () => {
  const dispatch = useAppDispatch();
  const { theme } = useSwitchTheme();

  const warning_modal = useAppSelector(selectWarning, shallowEqual);
  const { warning } = useAppSelector(selectSettings, shallowEqual);

  const closeModal = useCallback(async () => {
    dispatch(setModal({ warning: false }));
  }, [dispatch]);

  const renderWarning = useMemo(() => {
    if (typeof warning === 'string') {
      return <p className={cn.message}>{warning}</p>;
    }
    return warning?.map((w: string) => (
      <li key={uuidv4()}>
        <p className={cn.message}>{w}</p>
      </li>
    ));
  }, [warning]);

  return (
    <Modal
      margin="50px 0px 0px 0px"
      show={warning_modal}
      name="warning"
      width={500}
      close_box={57}
      padding={20}
      onClose={closeModal}
      standard={false}
      custom_close_icon={faXmark}
    >
      <div
        className={cn.headerWrapper}
        style={{
          color: theme.font_color,
          backgroundColor: theme.element_background,
          borderBottom: theme.border,
        }}
      >
        <p>Warning!</p>
      </div>
      <div className={cn.contentWrapper}>
        <img src={`${PUBLIC_URL}/empty-states-pc.svg`} alt="Cognitiv" />
        <div>
          <ul className={cn.warnings}>{renderWarning}</ul>
        </div>
      </div>
      <div className={cn.buttonsWrapper}>
        <Button width={115} button_size="medium" variant="blue" onClick={closeModal}>
          Ok
        </Button>
      </div>
    </Modal>
  );
};
